// @flow
import moment from 'moment';
import { ISO_DATE } from 'common/domain/DateRange';
import * as TimeResolution from 'statsradio/modules/metrics/domain/TimeResolution';

export type HistoryEntryData = {
  from: string;
  to: string;
  reach: number;
  listeningTime: number;
  interpolated?: boolean;
}

export default class HistoryEntry {
  from: moment;
  to: moment;
  reach: number;
  listeningTime: number;
  interpolated: boolean;

  constructor(from: moment, to: moment, reach: number, listeningTime: number, interpolated: boolean) {
    this.from = from;
    this.to = to;
    this.reach = reach;
    this.listeningTime = listeningTime;
    this.interpolated = interpolated;
  }

  startsAtOrAfter(date: moment) {
    return this.from.isSameOrAfter(date);
  }

  has(date: moment): boolean {
    return date.isBetween(this.from, this.to, 'day', '[]');
  }

  withHourlyListeningTime(): HistoryEntry {
    const listeningTimeInHours = TimeResolution.convertSeconds(this.listeningTime, 'HOURS');
    return new HistoryEntry(this.from, this.to, this.reach, listeningTimeInHours, this.interpolated);
  }

  toJSON(): HistoryEntryData {
    return {
      from: this.from.format(ISO_DATE),
      to: this.to.format(ISO_DATE),
      reach: this.reach,
      listeningTime: this.listeningTime,
      interpolated: this.interpolated,
    };
  }

  isSame(other: HistoryEntry) {
    if (this === other) {
      return true;
    }

    return this.from.isSame(other.from, 'day')
      && this.to.isSame(other.to, 'day')
      && this.reach === other.reach
      && this.listeningTime === other.listeningTime;
  }

  static parse(data: HistoryEntryData) {
    return new HistoryEntry(moment(data.from, ISO_DATE), moment(data.to, ISO_DATE), data.reach, data.listeningTime, Boolean(data.interpolated));
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/history/domain/HistoryEntry.js